// extracted by mini-css-extract-plugin
module.exports = {"leftBoxIcon":"ob_TPWyJp","horizontalScroll":"ob_RtE97b","header":"ob_Xz6Qvb"};